import React from "react";
import CareQualityFooter from "./CareQualityFooter";
import ReviewCard from "./ReviewCard";
import Stepper from "./Stepper";
import reviews from "./reviewsData";

const NavStepper = ({ currentPath, isTopMenu }) => {
  const showCallNowButtonForPaths = [
    "",
    "callback",
    "condition",
    "age",
    "eligibility-success",
    "eligibility-error",
    "eligibility-age-error",
  ];
  const showReviewForPaths = ["order-success"];
  const showStepperForPaths = [
    "",
    "callback",
    "condition",
    "age",
    "personal-details",
    "order-confirm",
  ];
  const showMedicalStepperForPaths = [
    "additional-info",
    "id-upload",
    "kyc-document",
    "gp-details",
  ];

  return (
    <>
      {showStepperForPaths.includes(currentPath) && (
        <>
          <div className="col-md-12 ">
            <p className="mt-1 fw-bold fs-6">What happens next?</p>
            <div class="col-md-12">
              <Stepper
                imgSrc={
                  currentPath === "personal-details" ||
                    currentPath === "order-confirm"
                    ? "/images/eligibility/check-circle-active.svg"
                    : "/images/eligibility/check-circle.svg"
                }
                imgAlt="Eligibility"
                title="Check your eligibility"
                description="Determine your eligibility for a medical cannabis consultation over a simple questionnaire."
                lineType="solid"
              />
              <Stepper
                imgSrc={
                  currentPath === "personal-details" ||
                    currentPath === "order-confirm"
                    ? "/images/eligibility/account-active.svg"
                    : "/images/eligibility/account-primary.svg"
                }
                imgAlt="Create Account"
                title="Create an account"
                description="Create your Treat-It account to conduct video calls with your clinician and manage your prescriptions."
                lineType="dashed"
              />
              <Stepper
                imgSrc="/images/eligibility/note.svg"
                imgAlt="Book Appointment"
                title="Book your appointment"
                description="Choose a date and time for your 30 min initial consultation online with our clinician."
                lineType="dashed"
              />
            </div>
          </div>
          <hr className="border gray-border mb-4 mt-0 mb-md-5 mt-md-2 w-100" />
        </>
      )}

      {showMedicalStepperForPaths.includes(currentPath) && (
        <>
          <div className="col-md-12 ">
            <p className="mt-1 fw-bold fs-6">What happens next?</p>
            <div class="col-md-12">
              <Stepper
                imgSrc={
                  currentPath === "gp-details"
                    ? "/images/eligibility/directbox-primary.svg"
                    : "/images/eligibility/directbox-active.svg"
                }
                imgAlt="Document"
                title="Share my GP details"
                description="Your GP Details will be used to get your health records and assess your suitability for medical cannabis treatment."
                lineType="dashed"
              />
              <Stepper
                imgSrc={
                  currentPath === "additional-info" || currentPath === "gp-details"
                    ? "/images/eligibility/document-primary.svg"
                    : "/images/eligibility/document-active.svg"
                }
                imgAlt="Document"
                title="Upload medical documents & add notes"
                description="Please share supporting documents with us as this often accelerates the approval process."
                lineType="dashed"
              />
              <Stepper
                imgSrc={
                  currentPath === "kyc-document"
                    ? "/images/eligibility/user-tag-active.svg"
                    : "/images/eligibility/user-tag-primary.svg"
                }
                imgAlt="Photograph"
                title="Upload a photograph for your medical cannabis card"
                description="Upload a photograph of yourself as per the UK digital photo guidelines."
                lineType="dashed"
              />
              <Stepper
                imgSrc="/images/eligibility/note.svg"
                imgAlt="Book Appointment"
                title="Upload KYC identification document"
                description="Please upload an accepted form of Identification"
                lineType="dashed"
              />
            </div>
          </div>
          <hr className="border gray-border mb-4 mt-0 mb-md-5 mt-md-2 w-100" />
        </>
      )}

      <div className="col-md-12">
        <ReviewCard
          currentPath={currentPath}
          isTopMenu={isTopMenu}
          review={reviews[0]}
          avatarSrc={reviews[0].profile}
        />

        {showReviewForPaths.includes(currentPath) && (
          <div className="mt-5">
            <ReviewCard
              currentPath={currentPath}
              isTopMenu={isTopMenu}
              avatarSrc={reviews[1].profile}
              review={reviews[1]}
            />
          </div>
        )}
      </div>

      {showCallNowButtonForPaths.includes(currentPath) && (
        <>
          <hr className="border gray-border my-4 my-md-5 w-100" />
          <div className="col-md-12">
            <div className="d-flex flex-row gap-4 gap-xl-12 justify-content-between align-items-center">
              <div>
                <p
                  className={`mb-0 ${currentPath === "eligibility-success" ||
                    (currentPath === "eligibility-error" && !isTopMenu) ||
                    (currentPath === "eligibility-age-error" && !isTopMenu)
                    ? "text-white"
                    : "text-black"
                    }`}
                >
                  You can easily book an
                </p>
                <p
                  className={`mb-0 ${currentPath === "eligibility-success" ||
                    (currentPath === "eligibility-error" && !isTopMenu) ||
                    (currentPath === "eligibility-age-error" && !isTopMenu)
                    ? "text-white"
                    : "text-black"
                    }`}
                >
                  appointment by giving us a call.
                </p>
              </div>
              <a
                href="https://wa.me/442477450738"
                target="_blank"
                rel="noopener noreferrer"
                className={`d-flex align-items-center justify-content-center gap-2 flow-gap py-2 px-3 h-fit fw-bold text-decoration-none border rounded bg-transparent text-nowrap ${currentPath === "eligibility-success" ||
                  (currentPath === "eligibility-error" && !isTopMenu) ||
                  (currentPath === "eligibility-age-error" && !isTopMenu)
                  ? "text-white border-white"
                  : "text-primary-600 border-primary-600"
                  }`}
              >
                <img
                  src={
                    currentPath === "eligibility-success" ||
                      (currentPath === "eligibility-error" && !isTopMenu) ||
                      (currentPath === "eligibility-age-error" && !isTopMenu)
                      ? "/images/eligibility/whatsapp-white.svg"
                      : "/images/vectors/whatsapp.svg"
                  }
                  alt="completed"
                  className="google-icon"
                />
                Call now
              </a>
            </div>
          </div>
        </>
      )}
      <hr className="border gray-border my-4 my-md-5 w-100" />
      <div className="col-md-12">
        <CareQualityFooter currentPath={currentPath} isTopMenu={isTopMenu} />
      </div>
    </>
  );
};

export default NavStepper;
